import { authClient } from '~/lib/auth-client'
import type { VueAuthClient } from 'better-auth/vue'
import { COOKIE_KEYS } from '~/utils/constants'

function createHandler(checkSessionFn: () => Promise<boolean>) {
  return {
    get(_target: object, prop: string | symbol) {
      if (prop === 'checkSession') return checkSessionFn
      // authClient is itself a Proxy — delegate all other access directly
      return (authClient as Record<string | symbol, unknown>)[prop]
    },
  }
}

export function useAuth(): typeof authClient & {
  checkSession: () => Promise<boolean>
} {
  const checkSession = async (): Promise<boolean> => {
    if (import.meta.server) {
      const token = useCookie(COOKIE_KEYS.SESSION_TOKEN)
      return !!token.value
    }
    try {
      const { data } = await authClient.getSession()
      return !!data
    } catch {
      return false
    }
  }

  // Return a Proxy instead of spreading because authClient is itself a Proxy,
  // and spreading a Proxy only copies its target's own properties (none).
  return new Proxy({}, createHandler(checkSession)) as ReturnType<typeof useAuth>
}
